import { render, staticRenderFns } from "./editPermissionGroup.vue?vue&type=template&id=ba3dd2d2&"
import script from "./editPermissionGroup.vue?vue&type=script&lang=ts&"
export * from "./editPermissionGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports